import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import ServicesOnlinePage from "./pages/ServicesOnlinePage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-[#F8F9FA]">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/properties" element={<PropertiesPage />} />
              <Route path="/properties/:id" element={<PropertyDetailPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/news/:slug" element={<NewsDetailPage />} />
              <Route path="/servizi-online" element={<ServicesOnlinePage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
            </Routes>
          </main>
          <Footer />
          <ChatBot />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0A1428",
                color: "white",
                border: "1px solid #C5A059",
                borderRadius: 0,
              },
            }}
          />
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
